import { onMounted, onUnmounted } from 'vue'

export function useScrollReveal() {
  let intersectionObserver = null
  let mutationObserver = null

  function observe(el) {
    if (!el.classList.contains('visible')) {
      intersectionObserver.observe(el)
    }
  }

  onMounted(() => {
    intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible')
          intersectionObserver.unobserve(entry.target)
        }
      })
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -60px 0px'
    })

    document.querySelectorAll('[data-reveal]').forEach(observe)

    mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return
          if (node.hasAttribute && node.hasAttribute('data-reveal')) observe(node)
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-reveal]').forEach(observe)
          }
        })
      })
    })

    mutationObserver.observe(document.body, { childList: true, subtree: true })
  })

  onUnmounted(() => {
    if (intersectionObserver) intersectionObserver.disconnect()
    if (mutationObserver) mutationObserver.disconnect()
  })
}
